import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import Textarea from 'components/ContentBox/Global/Textarea/Textarea'
import Variants from '../StudyTest/AddQuestionsTemplates/Variants'
import TagQuestion from './components/TagQuestion'
import './AddQuestionsPlacementTest.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FileSelector from 'components/UI/FileSelector/FileSelector'

const AddQuestionsPlacementTest = () => {
  const {
    modalSettings: data,
    changeValue: changeValues,
    modalValues: getModalValues,
    check,
    changeValues: changeValuesArray,
    listInKeyChangeHandler,
    deleteValidField,
  } = asideModalStore

  const qTypes = [
    {
      type: 'image_text_variants',
      supported: 'png, jpeg, jpg',
      m_type: 'image',
    },
    {
      type: 'audio_text_variants',
      supported: 'mp3, wav, ogg',
      m_type: 'audio',
    },
    {
      type: 'video_text_variants',
      supported: 'avi, mov, mpeg',
      m_type: 'video',
    },
    { type: 'image_text_field', supported: 'png, jpeg, jpg', m_type: 'image' },
    { type: 'audio_text_field', supported: 'mp3, wav, ogg', m_type: 'audio' },
    { type: 'video_text_field', supported: 'avi, mov, mpeg', m_type: 'video' },
  ]

  const setVatiants = (arr, key) => {
    listInKeyChangeHandler(arr, key)
  }

  const addMedia = (file, name) => {
    changeValues(typeof file === 'string' ? file : file[0], name)
  }

  useEffect(() => {
    const type = getModalValues?.question_type || ''
    deleteValidField()
    data.valid = {
      ...data.valid,
      question_data: type.includes('question_tag_variants')
        ? 'widget_tag_variants'
        : type.includes('variants')
          ? 'widget_question_variants'
          : type.includes('make_sentence')
            ? 'widget_make_sentence'
            : type.includes('text_field')
              ? 'widget_text_field'
              : '',
    }
  }, [getModalValues])

  useEffect(() => {
    if (!data.is_put) return
    const types = ['image', 'audio', 'video']
    const newValues = { ...getModalValues }
    types.forEach((key) => {
      if (newValues[key] === null) {
        delete newValues[key]
      }
    })
    changeValuesArray(newValues)
  }, [])

  const createBody = (type) => {
    switch (type) {
      case 'question_text_variants':
        return (
          <Variants
            och={setVatiants}
            name='question_data'
            value_name='name'
            data={getModalValues.question_data || false}
            error={check('question_data')}
          />
        )
      case 'question_text_field':
      case 'make_sentence':
        return (
          <>
            <FormField>
              <FormLabel>Текст ответа</FormLabel>
              <Textarea
                onChange={(data) =>
                  changeValues({ correct_answer: data }, 'question_data')
                }
                update={data.is_put}
                value={getModalValues?.question_data?.correct_answer}
                error={check('question_data')}
                stateName={'question_data'}
              />
            </FormField>
            {type === 'make_sentence' && (
              <div className='super-modal-notice'>
                <p>
                  Напишите предложения и разделите слова вертикальной чертой.
                  Слова автоматически перемешаются после сохранения.
                </p>
                <br />
                <p>
                  <strong>Пример:</strong>
                </p>
                <p>We|moved|to|California|last|summer</p>
              </div>
            )}
          </>
        )
      case 'image_text_field':
        return (
          <>
            <FormField>
              <FormLabel>Текст ответа</FormLabel>
              <Textarea
                onChange={(data) =>
                  changeValues({ correct_answer: data }, 'question_data')
                }
                update={data.is_put}
                value={getModalValues?.question_data?.correct_answer}
                error={check('question_data')}
                stateName={'question_data'}
              />
            </FormField>
            <FileSelector
              type={'image'}
              error={check('image')}
              types={['png', 'jpg', 'jpeg']}
              value={getModalValues.image || ''}
              onChange={(image) => {
                changeValues(image, 'image')
              }}
            />
          </>
        )
      case 'audio_text_field':
        return (
          <>
            <FormField>
              <FormLabel>Текст ответа</FormLabel>
              <Textarea
                onChange={(data) =>
                  changeValues({ correct_answer: data }, 'question_data')
                }
                update={data.is_put}
                value={getModalValues?.question_data?.correct_answer}
                error={check('question_data')}
                stateName={'question_data'}
              />
            </FormField>
            <FileSelector
              type={'audio'}
              error={check('audio')}
              types={['mp3', 'wav', 'ogg']}
              value={getModalValues.audio || ''}
              onChange={(audio) => {
                changeValues(audio, 'audio')
              }}
            />
          </>
        )
      case 'video_text_field':
        return (
          <>
            <FormField>
              <FormLabel>Текст ответа</FormLabel>
              <Textarea
                onChange={(data) =>
                  changeValues({ correct_answer: data }, 'question_data')
                }
                update={data.is_put}
                value={getModalValues?.question_data?.correct_answer}
                error={check('question_data')}
                stateName={'question_data'}
              />
            </FormField>
            <FileSelector
              type={'video'}
              error={check('video')}
              types={['avi', 'mov', 'mp4']}
              value={getModalValues.video || ''}
              onChange={(video) => {
                changeValues(video, 'video')
              }}
            />
          </>
        )
      case 'question_tag_variants':
        return (
          <TagQuestion
            onChange={(tags) => listInKeyChangeHandler(tags, 'question_data')}
            value={getModalValues?.question_data || false}
            error={check('question_data')}
          />
        )
      case 'image_text_variants':
        return (
          <>
            <FileSelector
              type={'image'}
              error={check('image')}
              types={['png', 'jpg', 'jpeg']}
              value={getModalValues.image || ''}
              onChange={(image) => {
                changeValues(image, 'image')
              }}
            />
            <Variants
              och={setVatiants}
              name='question_data'
              value_name='name'
              data={getModalValues.question_data || false}
              error={check('question_data')}
            />
          </>
        )
      case 'audio_text_variants':
        return (
          <>
            <FileSelector
              type={'audio'}
              error={check('audio')}
              types={['mp3', 'wav', 'ogg']}
              value={getModalValues.audio || ''}
              onChange={(audio) => {
                changeValues(audio, 'audio')
              }}
            />
            <Variants
              och={setVatiants}
              name='question_data'
              value_name='name'
              data={getModalValues.question_data || false}
              error={check('question_data')}
            />
          </>
        )
      case 'video_text_variants':
        return (
          <>
            <FileSelector
              type={'video'}
              error={check('video')}
              types={['avi', 'mov', 'mp4']}
              value={getModalValues.video || ''}
              onChange={(video) => {
                changeValues(video, 'video')
              }}
            />
            <Variants
              och={setVatiants}
              name='question_data'
              value_name='name'
              data={getModalValues.question_data || false}
              error={check('question_data')}
            />
          </>
        )
      default:
        return (
          <div className='super-modal-probe'>
            <p>Для начала выберите тип вопроса</p>
          </div>
        )
    }
  }

  return (
    <div className='addQuestionsPlacementTest'>
      <div className='modalAddPayment'>
        <FormField>
          <FormLabel>Тип вопроса</FormLabel>
          <SelectCustom
            placeholder='Типы и названия вопросов:'
            apiLink='placement_test/question_types'
            error={check('question_type')}
            optionValueKey='value'
            valueID={getModalValues?.question_type}
            onChange={(o) =>
              changeValuesArray({
                right_answer_scores: 1,
                question_type: o.value,
                bundle: getModalValues.bundle,
              })
            }
            isDisabled={data.is_put}
          />
        </FormField>
        {!!getModalValues.question_type && (
          <FormField>
            <FormLabel>Текст вопроса</FormLabel>
            <Textarea
              onChange={changeValues}
              update={data.is_put}
              value={getModalValues?.question_text}
              stateName='question_text'
              error={check('question_text')}
            />
          </FormField>
        )}
        {createBody(getModalValues.question_type)}

        {!!getModalValues.question_type && (
          <div className='addQuestionsPlacementTest__correctAnswer'>
            <FormLabel>Баллов за правильный ответ</FormLabel>
            <FormInput>
              <input
                placeholder='Баллов за правильный ответ'
                style={{ textAlign: 'center' }}
                type='number'
                value={getModalValues?.right_answer_scores || ''}
                onChange={(e) =>
                  changeValues(e.target.value, 'right_answer_scores')
                }
                className={
                  check('right_answer_scores')
                    ? 'super-modal__input--error'
                    : undefined
                }
              />
            </FormInput>
          </div>
        )}
      </div>
    </div>
  )
}
export default observer(AddQuestionsPlacementTest)
